import { Form, Formik } from "formik";
import { B2BButton } from "../../b2bbutton/b2bbutton";
import Input from "../../input/input";
import { authSchema } from '../../../constants/validation.constants';


interface SignInFormProps {
  onSubmit: (values: { email: string; password: string }) => Promise<any> | void;
  onChange: (values: { email: string; password: string }) => Promise<any> | void;
}

const SignInForm = ({onSubmit, onChange}: SignInFormProps) => {

  const initialValues = {
    email: '',
    password: '',
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ email: e.target.value, password: ''});
  };

  const handleSubmit = async(values:any, actions:any) => {
    try {
      await onSubmit(values);
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={authSchema}
      onSubmit={handleSubmit}
      validateOnBlur={true}
    >
      {({isValid, dirty, isSubmitting}) => (
        <Form>
          <div className="mb-4">
            <Input
              className="p-2"
              id="email"
              placeholder="Email*"
              name='email'
              type="email"
              onBlur={(e) => handleEmailChange(e)}
            />
          </div>
          <div className="mb-4">
            <Input
              id="password"
              placeholder="Password*"
              name="password"
              type="password"
            />
          </div>
          <B2BButton
            disable={!isValid || !dirty}
            expand={true}
            label="Sign in"
            theme="dark"
            isLoading={isSubmitting}
            onClick={() => {}}
            type="submit"
          />
        </Form>
      )}
    </Formik>
  );
};

export default SignInForm;